import { useEffect, useState } from 'react';

import { cn } from '@/lib/utils/cn';

interface ClientLogoProps {
  name: string;
  logoUrl?: string | null;
  sizeClassName: string;
  textClassName: string;
  className?: string;
}

export function ClientLogo({
  name,
  logoUrl,
  sizeClassName,
  textClassName,
  className,
}: ClientLogoProps) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const shouldShowLogo = Boolean(logoUrl) && failedUrl !== logoUrl;

  useEffect(() => {
    setFailedUrl(null);
  }, [logoUrl]);

  if (shouldShowLogo) {
    return (
      <img
        src={logoUrl ?? undefined}
        alt=""
        className={cn(sizeClassName, 'shrink-0 border border-border object-contain', className)}
        loading="lazy"
        referrerPolicy="no-referrer"
        onError={() => setFailedUrl(logoUrl ?? null)}
      />
    );
  }

  return (
    <div
      aria-hidden="true"
      className={cn(
        sizeClassName,
        'flex shrink-0 items-center justify-center border border-border bg-surface-muted font-semibold uppercase tracking-wider text-muted',
        textClassName,
        className,
      )}
    >
      {name.slice(0, 2)}
    </div>
  );
}
